import React from 'react';
import styled from 'styled-components';
import { buildImageSource, buildImageSourceSet } from '../../utils/buildImageSource';
import { Image } from '../media/Image';
import { Img } from '../media/Img';
import type { ContentUI } from './types';

const VideoTag = styled.video.withConfig({ displayName: 'VideoTag' }).attrs({
    playsInline: true,
    muted: true,
    preload: 'auto',
    autoPlay: false,
})`
    object-fit: cover;
    object-position: center;
`;

interface MediaPreviewProps {
    namespace?: string;
    media: ContentUI;
    lazyLoad?: boolean;
    imageSize?: { width: number; height: number };
}

export const MediaPreview = (props: MediaPreviewProps) => {
    const { media, namespace, lazyLoad = true, imageSize } = props;

    const ImgComponent = lazyLoad ? Image : Img;

    if (media.type === 'image') {
        return (
            <ImgComponent
                src={buildImageSource(media.media, namespace, imageSize)}
                srcSet={buildImageSourceSet(media.media, namespace, imageSize)}
            />
        );
    }

    const [firstMedia] = media.media;

    if (media.type === 'video') {
        if (firstMedia.previewFormats) {
            return (
                <ImgComponent
                    src={buildImageSource(firstMedia.previewFormats, namespace, imageSize)}
                    srcSet={buildImageSourceSet(firstMedia.previewFormats, namespace, imageSize)}
                />
            );
        }
        if (firstMedia.firstFrameUrl) {
            return <ImgComponent src={firstMedia.firstFrameUrl} />;
        }

        return (
            <VideoTag>
                <source src={firstMedia.url} />
            </VideoTag>
        );
    }

    return null;
};
